export const baseRetry = async <T>(
	fn: () => Promise<T>, // aws amplify api call
	retries = 4, //count of retries
	delay = 700 //700 milliseconds
): Promise<T> => {
	try {
		return await fn();
	} catch (err) {
		if (retries <= 0) throw err; //throw error when reached failed retry count
		await new Promise((res) => setTimeout(res, delay)); //delay before retry
		return baseRetry(fn, retries - 1, delay); //retry api
	}
};
